import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="BATSU GAME de Yankee Onna ni Kokuttemita parte 3"
      portada="https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-1.jpg"
      paginas={[
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-2.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-3.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-4.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-5.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-6.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-7.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-8.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-9.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-10.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-11.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-12.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-13.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-14.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-15.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-16.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-17.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-18.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-19.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-20.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-21.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-22.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-23.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-24.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-25.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-26.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-27.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-28.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-29.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-30.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-31.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-32.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-33.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-34.jpg",
  "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-35.jpg"
]}
      sugeridos={[]}


      info={{
     grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Beauty Mark", "Big Ass", "Big Breasts", "Blowjob", "Cheating", "Digital", "Freckles", "Kissing", "Milf", "Multi-work Series", "Netorare", "Paizuri", "Sole Male", "Sweating", "Tall Girl", "Widow"],     
   artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "BATSU GAME de Yankee Onna ni Kokuttemita parte 3",
  portada: "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-1.jpg",
  reverso: "https://fullcomics18.org/img12/batsu-game-de-yankee-onna-ni-kokuttemita3-8.jpg",

  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Beauty Mark", "Big Ass", "Big Breasts", "Blowjob", "Cheating", "Digital", "Freckles", "Kissing", "Milf", "Multi-work Series", "Netorare", "Paizuri", "Sole Male", "Sweating", "Tall Girl", "Widow"],     
    artistas: "Fuetakishi",
  },
};
